import { WeaTools } from 'ecCom';

export const checkTableFieldValueUnique = params => WeaTools.callApi('/api/integration/common1/checkTableFieldValueUnique', 'POST', params);
export const checkCasIsDeployed = params => WeaTools.callApi('/api/integration/common1/checkCasIsDeployed', 'POST', params);
export const checkValidateCode = params => WeaTools.callApi('/api/integration/common1/checkValidateCode', 'POST', params);
export const checkNonstandardStatus = params => WeaTools.callApi('/api/integration/common1/checkNonstandardStatus', 'GET', params);
export const checkIsHasOrganization = params => WeaTools.callApi('/api/common/hrmcommon/getManageDetachEnable', 'POST', params);



// WEBPACK FOOTER //
// ../src4js/pc4backstage/integration/apis/CommonService.js